export default function aggregateActionsBreakdown(
  actions: Array<{
    capitalBreakdown: Array<{
      commitmentId: string;
      fundsCalled?: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }>;
  }>,
) {
  const aggregatedBreakdown = new Map<
    string,
    {
      commitmentId: string;
      fundsCalled: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }
  >();

  actions.forEach((action) => {
    action.capitalBreakdown.forEach((breakdown) => {
      const commitmentId = breakdown.commitmentId;
      const existingBreakdown = aggregatedBreakdown.get(commitmentId) ?? {
        commitmentId,
        fundsCalled: {
          fromCommitmentLcy: 0,
          fromRecallableDistributionLcy: 0,
        },
      };

      existingBreakdown.fundsCalled.fromCommitmentLcy +=
        breakdown.fundsCalled?.fromCommitmentLcy ?? 0;
      existingBreakdown.fundsCalled.fromRecallableDistributionLcy +=
        breakdown.fundsCalled?.fromRecallableDistributionLcy ?? 0;

      aggregatedBreakdown.set(commitmentId, existingBreakdown);
    });
  });

  return Array.from(aggregatedBreakdown.values());
}
